import { render } from "./DetailProduct.vue?vue&type=template&id=a467f62a&scoped=true"
import script from "./DetailProduct.vue?vue&type=script&lang=js"
export * from "./DetailProduct.vue?vue&type=script&lang=js"

import "./DetailProduct.vue?vue&type=style&index=0&id=a467f62a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a467f62a"]])

export default __exports__